<template>
  <div class="sign-pg">
    <div class="sign-row">
      <div class="sign-form-top">
        <h2>{{ $t('Сбросить пароль') }}</h2>
      </div>
      <div>
        <small>
          Проверьте свою электронную почту, чтобы найти ссылку для сброса
          пароля. Если он не появится в течение нескольких минут, проверьте
          папку со спамом.
        </small>
      </div>
      <router-link tag="button" :to="$i18nRoute({ name: 'login' })" class="btn btn-default grad">
        {{ $t('Вернитесь чтобы войти') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'password-reset',
  data: () => ({
    title: '',
    description: '',
    keywords: ''
  }),
  metaInfo () {
    return {
      title: this.title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: this.description,
      }, {
        vmid: 'keywords',
        name: 'keywords',
        content: this.keywords,
      }]
    }
  },
  created() {
    this.scrollToTop()
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-pg {
    margin-bottom: 40px;
}
small {
  display: block;
  margin-bottom: 40px;
  text-align: center;
}
</style>
